export const formatRangeLabel = (minValue, maxValue, min, max, type, units) => {
  if (minValue === 0 && maxValue === max) {
    return `Any ${type}`
  }

  if (minValue === 0) {
    return `Less than ${maxValue} ${units}`
  }

  if (maxValue === max) {
    return `More than ${minValue} ${units}`
  }

  return `${minValue} - ${maxValue} ${units}`
}
